export class ClientResponse {
  constructor(data = [], errores = [], mensaje = "") {
    this.data = data;
    this.errores = errores;
    this.mensaje = mensaje;
    this.success = null;
    this.info = null;
  }

 _generate = async (objPromise) => {
    try {
      const res = await objPromise;

      this.data    = res?.data ?? null;
      this.errores = res?.errores ?? null;
      this.mensaje = res?.mensaje ?? null;

      this.success = res?.status === 200;

      if (this.success && Array.isArray(res.data) && res.data[0]?.docs) {
        this.info = res.data[0].docs[0];
      }

      return this; // resolve(this)
    } catch (error) {
      console.log(error);
      this.success = false;
      throw this;  // reject(this)
    }
  };
}
